const {
  DEFAULT_CURRENCY,
  CRYPTO,
  DWOLLA,
  BANKS_ARR,
  WALLET_TRANSFER,
  TOKEN_FREE_APIS,
  SILAMONEY,
} = require("./stringconsts");

function camelize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

module.exports = {
  checkAuthToken: (url) => {
    const methodName = url.split("/").pop();
    return !(TOKEN_FREE_APIS.indexOf(methodName) !== -1);
  },
  enableBankPayment: (settings, paymentOptions, cartInfo) => {
    if (paymentOptions?.banks?.length) {
      if (settings && settings.displayCurrency) {
        if (settings.displayCurrency.toUpperCase() === DEFAULT_CURRENCY) {
          return true;
        }
        return false;
      }
      if (
        !!cartInfo?.currency &&
        cartInfo?.currency.toUpperCase() === DEFAULT_CURRENCY
      ) {
        return true;
      }
    }
    return false;
  },
  isCryptoEnabled: (paymentOptions) => {
    if (paymentOptions?.exchanges?.length) {
      return true;
    }
    return false;
  },
  isWalletEnabled: (paymentOptions) => !!paymentOptions?.wallets?.length,
  isWalletPayment: (nameStock) =>
    nameStock && nameStock.toUpperCase() === WALLET_TRANSFER,
  isCryptoPayment: (nameStock) =>
    nameStock && nameStock.toUpperCase() === CRYPTO,
  isBankPayment: (nameStock) =>
    nameStock &&
    (nameStock.toUpperCase() === DWOLLA ||
      nameStock.includes(DWOLLA.toLowerCase()) ||
      BANKS_ARR.indexOf(nameStock.toLowerCase()) !== -1),
  containsDwolla: (paymentOptions) =>
    paymentOptions.banks?.includes(DWOLLA.toLowerCase()),
  isBankToBankTransfer: (paymentMethod) =>
    paymentMethod && BANKS_ARR.indexOf(paymentMethod.toLowerCase()) !== -1,
  isUSD: (currencyName) => currencyName.toUpperCase() === DEFAULT_CURRENCY,
  usdCurrencyName: () => DEFAULT_CURRENCY,
  getUpperCase: (txt) => txt.toUpperCase(),
  getLowerCase: (txt) => txt.toLowerCase(),
  getStockLogo: (key) => {
    let icon = "";
    try {
      // eslint-disable-next-line
      icon = require(`@/assets/img/wallets/${key}.svg`);
    } catch {
      // eslint-disable-next-line
      icon = require("@/assets/img/wallets/bank.svg");
    }
    return icon;
  },
  removeDwollaFromStock: (stocks) => {
    const index = stocks.map((e) => e.name).indexOf(camelize(DWOLLA));
    const index2 = stocks.map((e) => e.name).indexOf(DWOLLA.toLowerCase());
    if (index !== -1) {
      stocks.splice(index, 1);
    }
    if (index2 !== -1) {
      stocks.splice(index2, 1);
    }
    return stocks;
  },
  removeSilaFromStock: (stocks) => {
    const index = stocks.map((e) => e.name).indexOf(camelize(SILAMONEY));
    const index2 = stocks.map((e) => e.name).indexOf(SILAMONEY.toLowerCase());
    if (index !== -1) {
      stocks.splice(index, 1);
    }
    if (index2 !== -1) {
      stocks.splice(index2, 1);
    }
    return stocks;
  },
  routeParser: (route) => {
    if (route.query?.data) {
      try {
        return { data: JSON.parse(route.query.data) };
      } catch (error) {
        return true;
      }
    } else {
      return true;
    }
  },
  isMobileAgent: () => {
    try {
      return /(Mobi|Android|iPhone|iPad|iPod|BlackBerry|Opera Mini|Kindle|Silk|WebOS|Windows Phone)/i.test(
        navigator?.userAgent
      );
    } catch (error) {
      return false;
    }
  },
  isInIframe: () => {
    try {
      return window.self !== window.top;
    } catch (error) {
      return true;
    }
  },
};
